export const user_login_initial_values = {
  email: "",
  password: "",
};

export const device_initialValues = {
  brand: "",
  model: "",
  imei: "",
  ram: "",
  rom: "",
  deviceCondition: "",
  purchasedFrom: "",
  purchasedFromContactNo: "",
  purchaseCost: 0,
  purchaseDate: "",
  soldTo: "",
  soldToContactNo: "",
  soldPrice: 0,
  soldDate: "",
  profit: "",
  romUnit: "GB",
};
